import { AxiosInstance } from 'axios';
import { ReservationSummaryService } from 'services/Reservations';

export interface ReservationSummaryServiceModel {
  saveSummary: ReturnType<typeof ReservationSummaryService.saveSummary>;
}

export const initReservationSummaryService = (
  axios: AxiosInstance
): ReservationSummaryServiceModel => ({
  saveSummary: ReservationSummaryService.saveSummary(axios),
});
